/** @module Specification/BOM/BOMSizesRenderer */
define([
	"dojo/_base/declare",
	"Apparel/ProductSize/_SizesRenderer"
], function(declare,_SizesRenderer) {

	return declare(_SizesRenderer, {
		/**
		 * @override
		 * Return size range of parent product
		 */
		getSizeRange: function(ctx) {
			const {cache} = ctx;
			const bom = ctx.getNodeParent();
			const product = cache.get(bom.__Parent__);

			// could be a BOM template, although template should never have sizes
			if (!product) {
				return null;
			}

			const attributes = cache.get(product.Attributes);
			return cache.get(attributes?.ActualSizeRange);
		}
	});
});